module.exports = __webpack_public_path__ + "static/media/filterDarkSvg.40cc3caf.svg";